<muni-gameday-panel
  [title]="'Summary'"
  [linkUrl]="monitorUrl"
  [linkText]="'View Order Monitor'"
  condensed="true"
  data-automation-e2e-selector="summaryCardPanel"
>
  <div class="component">
    <div class="row">
      <div class="column" data-automation-e2e-selector="totalOrders">
        <span
          class="value"
          [textContent]="
            (summary.amount | currency: 'USD':'symbol':'3.0-0') || '-'
          "
          data-automation-e2e-selector="value"
        >
        </span>
        <span
          *ngIf="summary.subscription >= 1"
          class="subValue"
          [textContent]="subscriptionFormatter(summary.subscription)"
          data-automation-e2e-selector="subscription"
        ></span>
        <span class="label" data-automation-e2e-selector="label"
          >Total Orders (M)</span
        >
      </div>
      <div class="column" data-automation-e2e-selector="timer">
        <muni-gameday-countdown></muni-gameday-countdown>
      </div>
    </div>
    <muni-gameday-progress-bar
      [value]="summary.fillPercent || 0"
      height="30"
      data-automation-e2e-selector="totalFillPercentage"
    >
    </muni-gameday-progress-bar>
    <div class="row">
      <div class="column" data-automation-e2e-selector="totalFill">
        <span
          class="value"
          [textContent]="
            (summary.fill | currency: 'USD':'symbol':'3.0-0') || '-'
          "
          data-automation-e2e-selector="value"
        >
        </span>
        <span class="label" data-automation-e2e-selector="label">Fill (M)</span>
      </div>
      <div
        class="column  alignedRight"
        data-automation-e2e-selector="totalBalance"
      >
        <span
          class="balancevalue"
          [textContent]="
            (summary.balance | currency: 'USD':'symbol':'3.0-0') || '-'
          "
          data-automation-e2e-selector="value"
        >
        </span>
        <span class="label" data-automation-e2e-selector="label"
          >Balance (M)</span
        >
      </div>
    </div>
    <div class="row" *ngIf="!oneBar">
      <div
        [ngClass]="columnClassName"
        *ngIf="hasShort"
        data-automation-e2e-selector="shortFillPercentage"
      >
        <muni-gameday-progress-bar
          [value]="summary.shortPercent || 0"
          data-automation-e2e-selector="progressBar"
        >
        </muni-gameday-progress-bar>
        <span class="label">Short (0-10 yr) fill</span>
      </div>
      <div
        [ngClass]="columnClassName"
        *ngIf="hasMid"
        data-automation-e2e-selector="midFillPercentage"
      >
        <muni-gameday-progress-bar
          [value]="summary.midPercent || 0"
          data-automation-e2e-selector="progressBar"
        >
        </muni-gameday-progress-bar>
        <span class="label">Mid (11-20 yr) fill</span>
      </div>
      <div
        [ngClass]="columnClassName"
        *ngIf="hasLong"
        data-automation-e2e-selector="longFillPercentage"
      >
        <muni-gameday-progress-bar
          [value]="summary.longPercent || 0"
          data-automation-e2e-selector="progressBar"
        >
        </muni-gameday-progress-bar>
        <span class="label">Long (21-30+ yr) fill</span>
      </div>
    </div>
  </div>
</muni-gameday-panel>
